<template>
    <v-tab-item :key="tab_key">
        <v-row class="pt-2 px-2">
            <v-col cols="3">
                <date-picker class="float-right" v-model="fecha" @change="cargarDatos" range-separator="|" range placeholder="Fecha Producción" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
            </v-col>
            <v-col :cols="!extra || !extra.sin_tipo_produccion ? '5' : '7'">
                <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
            </v-col>
            <v-col cols="2">
                <v-checkbox label="Mostrar solo sin folio" v-model="sin_folio" class="ma-0"></v-checkbox>
            </v-col>
            <v-col cols="2" v-if="!extra || !extra.sin_tipo_produccion">
                <v-select
                    :items="[{id: 1, nombre: 'Harina'}, {id: 2, nombre: 'Aceite'}]"
                    item-text="nombre"
                    item-value="id"
                    v-model="tipo_produccion"
                    label="Tipo de producción"
                    class="ma-0"
                    @change="cargarDatos"
                ></v-select>
            </v-col>
        </v-row>
        <v-data-table 
            :headers="cabeceras_modificadas"
            :items="datos_filtrados"
            :items-per-page="35"
            item-class="filita"
            class="elevation-2 mt-1"
            dense
        > 
            
            <template v-slot:item.fecha="{ item }">
                <span>{{  moment(item.fecha).format('DD-MM-YYYY') }}</span>
            </template>
            <template v-slot:item.folio="{ item }"> 
                <v-text-field v-if="tab_key === 'fol_harina'" :label="item['nombre_folio']" v-model="item['valor_folio']" @change="actualizarFolio(item)"></v-text-field>
                <v-text-field 
                    v-else-if="item.input_activado" 
                    label="Folio" 
                    :value="item[nombre_folio]" 
                    :messages="item.message[nombre_folio]" 
                    :success="item.success[nombre_folio]" 
                    :error="item.error[nombre_folio]"
                    :loading="item.loading[nombre_folio]"
                    @change="actualizarFolio(item, $event)"
                    @input="limpiar(item, nombre_folio)"
                ></v-text-field>
                <p v-else>{{ item[nombre_folio] }}</p>
            </template>
            <template v-if="tab_key === 'fol_desp'" v-slot:item.bodega_destino="{ item }">
                <v-select
                    v-model="item.bodega_destino"
                    :items="item.bod_modificable ? bodegas_filtradas : [bodegas_filtradas.find(bod => bod.id === item.bodega_destino)]"
                    label="Bodega destino"
                    item-text="nombre"
                    item-value="id"
                    color="blue darken-3"
                    @change="actualizarValores(item, 'bodega_destino')"
                    @input="limpiar(item, 'bodega_destino')"
                    :messages="item.message.bodega_destino" 
                    :success="item.success.bodega_destino" 
                    :error="item.error.bodega_destino"
                    :loading="item.loading.bodega_destino"
                ></v-select>
            </template>
            <template v-if="tab_key === 'fol_abas'" v-slot:item.lote_aceite="{ item }">
                <v-select
                    v-model="item.lotes_aceite_id"
                    :items="lotes_filtrados(item)"
                    label="Lote aceite"
                    item-text="nombre_lote"
                    item-value="id"
                    color="blue darken-3"
                    @change="actualizarValores(item, 'lotes_aceite_id')"
                    @input="limpiar(item, 'lotes_aceite_id')"
                    :messages="item.message.lotes_aceite_id" 
                    :success="item.success.lotes_aceite_id" 
                    :error="item.error.lotes_aceite_id"
                    :loading="item.loading.lotes_aceite_id"
                ></v-select>
            </template>
            <template v-if="tab_key === 'fol_harina'" v-slot:item.tipo_movimiento="{ item }">    
                <p>{{ item.tipo_movimiento === "I" ? "Ingreso" : "Salida" }}</p>
            </template>
            <template v-slot:item.observaciones="{ item }">
                <v-text-field 
                    label="Observaciones" 
                    v-model="item.observaciones" 
                    @change="actualizarValores(item, 'observaciones')"
                    @input="limpiar(item, 'observaciones')"
                    :messages="item.message.observaciones" 
                    :success="item.success.observaciones" 
                    :error="item.error.observaciones"
                    :loading="item.loading.observaciones"
                ></v-text-field>
            </template>
            <template v-slot:item.opciones="{ item }">
                <div class="d-flex">
                    <v-icon title="Editar" color="blue" @click="activarInput(item)" class="mx-2">edit</v-icon>
                </div> 
            </template>
        </v-data-table>
    </v-tab-item>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import Data_Table from '@/components/shared/Data_Table.vue';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    data() {
        return {
            fecha: new Date().toISOString().substring(0, 10),
            lista_datos: [],
            tipo_produccion: 1,
            sin_folio: false,
        }
    },
    props: {
        tab_key: String,
        url_datos: String,
        url_actualizar: String,
        cabeceras: Array,
        nombre_folio: String,
        extra: Object,
    },
    methods: {
        async cargarDatos() {
            this.mostrarLoading({titulo: "Cargando datos...", color: "blue"});
            const fecha_ini = this.moment(this.fecha[0]).format('YYYY-MM-DD');
            const fecha_fin = this.moment(this.fecha[1]).format('YYYY-MM-DD');
            const data = {
                "fecha_ini": fecha_ini,
                "fecha_fin": fecha_fin,
                "tipo_produccion": this.tipo_produccion,
                "sin_folio": this.sin_folio,
            }
            await this.axios.post(this.url_datos, data, this.headers).then(response => {
                console.log(response);
                this.lista_datos = response.data.data.map(dato => {
                    dato.success = {};
                    dato.error = {};
                    dato.message = {};
                    dato.loading = {};

                    if(this.extra && this.extra.valores_modificables) {
                        this.extra.valores_modificables.forEach(valor => {
                            dato.success[valor] = false;
                            dato.error[valor] = false;
                            dato.message[valor] = "";
                            dato.loading[valor] = false;
                        });
                    }

                    dato.success[this.nombre_folio] = false;
                    dato.error[this.nombre_folio] = false;
                    dato.message[this.nombre_folio] = "";
                    dato.loading[this.nombre_folio] = false;

                    dato.input_activado = dato[this.nombre_folio] ? false : true;

                    return dato;
                })
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async actualizarFolio(item, value) {
            const data = { [this.nombre_folio]: value };

            if(this.tab_key === 'fol_harina') {
                data.valor_folio = item.valor_folio;
                data.motivo_movimiento = item.motivo_movimiento_id;
                data.tipo_movimiento = item.tipo_movimiento;
            }

            if(data[this.nombre_folio]) {
                item.loading[this.nombre_folio] = true;
                const url = `${this.url_actualizar}/${item.id}`;
                await this.axios.post(url, data, this.headers).then(response => {
                    const fila_actualizada = response.data.data;
                    item.success[this.nombre_folio] = true;
                    item.message[this.nombre_folio] = "¡Folio actualizado con éxito!";
                    item[this.nombre_folio] = fila_actualizada[this.nombre_folio];
                }).catch((error)=>{                    
                    item.error[this.nombre_folio] = true;
                    item.message[this.nombre_folio] = "Error al actualizar el folio";

                    console.log(error);
                });
                item.loading[this.nombre_folio] = false;
            }
        },
        limpiar(item, valor_modificado) {
            item.success[valor_modificado] = false;
            item.message[valor_modificado] = "";
            item.error[valor_modificado] = false;
        },
        activarInput(item) {
            item.input_activado = !item.input_activado;
        },
        // Función genérica para actualizar columnas aparte del folio
        async actualizarValores(item, campo = null) {
            item.loading[campo] = true;
            const data = {};

            if(item.tipo_produccion_id) data.tipo_produccion_id = item.tipo_produccion_id;

            if(!campo) {
                this.extra.valores_modificables.forEach(val => {
                    data[val] = item[val];
                });
            } else {
                data[campo] = item[campo];
            }

            console.log({data});
            const url = `${this.url_actualizar}/${item.id}`;

            await this.axios.post(url, data, this.headers).then(response => {
                if(response.data.error) throw response.data.error;
                Object.keys(data).forEach(key => {
                    item.success[key] = true;
                    item.message[key] = `¡${key} actualizado con éxito!`;
                });
            }).catch((error)=>{
                Object.keys(data).forEach(key => {
                    item.error[key] = true;
                    item.message[key] = `Error al actualizar ${key}`;
                });

                console.log(error);
            });
            item.loading[campo] = false;
        },
        // Específico de la Tab "Folio Abastecimiento (Aceite)"
        lotes_filtrados(item) {
            return this.extra.lotes.filter(lote => lote.estanques_externos_id === item.estanques_externos_id);
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        cabeceras_modificadas() {
            if(this.tab_key === "fol_prod"){
                const cabeceras = [...this.cabeceras];
                cabeceras[6].text = `${this.tipo_produccion === 1 ? 'Cantidad Jumbos' : 'Estanque Aceite'}`;
                cabeceras[6].value = `${this.tipo_produccion === 1 ? 'cantidad_jumbos' : 'estanque'}`;
                
                return cabeceras;
            } else {
                return this.cabeceras;
            }
        },
        bodegas_filtradas() {
            return this.extra.bodegas.filter(bodega => bodega.tipo_produccion_id === this.tipo_produccion);
        },
        datos_filtrados() {
            return this.lista_datos.filter(dato => this.sin_folio ? !dato[this.nombre_folio] : true)
        },
        ...mapState(['base_url', 'headers', 'roles']),
    },
    components: {
        'data-table': Data_Table,
        DatePicker,
        ConfirmDialogue,
    }
}
</script>

<style scoped>
    .mx-datepicker{ width: 100% !important;}
</style>